const axios = require('axios');

export default class AddressController {
  constructor(resource) {
    this._resource = resource;
  }

  validaAddress(address) {
    if (
      address.zip == '' ||
      address.street == '' ||
      address.number == '' ||
      address.neighborhood == '' ||
      address.city == '' ||
      address.state == ''
    ) {
      return true;
    }
    return false;
  }

  register(address) {
    return this._resource.save(address).then(res => res.json());
  }

  async getAddressById(id_address) {
    try {
      let response = await this._resource(`address/${id_address}`).get();

      return response.body;
    } catch (error) {
      return {
        ok: false,
        message: error.body.message,
      };
    }
  }

  async create(address) {
    return this._resource(`address`)
      .save(address)
      .then(res => res.body)
      .catch(error => {
        throw error;
      });
  }

  async update(id_address, address) {
    try {
      let response = await this._resource(`address/${id_address}`).update(
        address
      );

      return response.body;
    } catch (e) {
      return e;
    }
  }

  async validaCep(cep) {
    let address = {
      street: null,
      zip: cep,
      street: null,
      city: null,
      neighborhood: null,
      state: null,
    };

    await axios
      .get(`https://viacep.com.br/ws/${cep}/json/`)
      .then(response => {
        address.state = response.data.uf;
        address.street = response.data.logradouro;
        address.city = response.data.localidade;
        address.neighborhood = response.data.bairro;
      })
      .catch(error => {
        throw error;
      });

    return address;
  }
}
